import { render, staticRenderFns } from "./TinyButton.vue?vue&type=template&id=141d0ac6&scoped=true&"
import script from "./TinyButton.vue?vue&type=script&lang=js&"
export * from "./TinyButton.vue?vue&type=script&lang=js&"
import style0 from "./TinyButton.vue?vue&type=style&index=0&id=141d0ac6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141d0ac6",
  null
  
)

export default component.exports